export default {
  setAllergens: (state, value) => (state.allergens = value),
  resetAllergens: (state) => (state.allergens = null),
  setLanguages: (state, value) => (state.languages = value),
  resetLanguages: (state) => (state.languages = null)
}
